import * as React from 'react';
import { axios_ } from '../../../tools/axios_';
import { ArrowDownOutlined, ReloadOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Input, Table, Select } from 'antd';
import { Link } from 'react-router-dom';
import './index.less';
import { connect } from 'react-redux';
import { initPageNamesConfig, Utils } from '../../../tools/utils';
import sensors from '../../../tools/sensors/autoTrack';


export const idTypeList = [
  { value: '01', label: "身份证" },
  { value: '02', label: "护照" },
  { value: '03', label: "驾驶证" },
  { value: '04', label: "港澳通行证" },
  { value: '05', label: "军官证" },
  { value: '06', label: "户口簿" },
  { value: '07', label: "组织机构代码" },
  { value: '08', label: "出生证明" },
  { value: '09', label: "中国护照" },
  { value: '10', label: "少儿证" },
  { value: '11', label: "学生证" },
  { value: '12', label: "台胞证" },
  { value: '13', label: "工作证" },
  { value: '14', label: "外国人永久居留证" },
  { value: '15', label: "士兵证" },
  { value: '16', label: "港澳回乡证" },
  { value: '17', label: "港澳台同胞证" },
  { value: '18', label: "工商注册号码" },
  { value: '19', label: "统一社会信用代码" },
  { value: '20', label: "税务登记证" },
  { value: '21', label: "营业执照" },
  { value: '22', label: "港澳台居住证" },
  { value: '23', label: "港澳身份证" },
  { value: '24', label: "外国人永久居留身份证" },
  { value: '25', label: "港澳居民来往内地通行证" },
  { value: '26', label: "台湾居民来往内地通行证" },
  { value: '27', label: "军人证" },
  { value: '28', label: "港澳台居民来往内地通行证" },
  { value: '31', label: "警官证" },
  { value: '32', label: "纳税人识别号" },
  { value: '33', label: "港澳台回乡证" },
  { value: '99', label: "其他证件" },
  { value: '100', label: "外国护照" },
  { value: '101', label: "台湾通行证" },
];

class ClientManage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      customerName: '',
      cidno: '',
      mobile: '',
      gender: '',
      agencyName: '',
      empno: '',
      groupId: '',

      groupOptions: [], //团队下拉列表
      dataSource: [],
      totals: 0,
      page: 1,
      limit: 10,
      tableLoading: false,
      companyIdList: [],//  所属机构列表
      companyId: '',//所属机构id
      pageNamesConfig: {} // 页面字段配置
    };
  }
  componentDidMount() {
    Utils.insertChama();//引入插码文件
    // 初始化页面展示字段（合作案）
    initPageNamesConfig('clientManage', 'list', this.props.token).then(res => {
      if (res.data.status === 200) {
        this.setState({ pageNamesConfig: res.data.data || {} });
      }
    });
    if (window.sessionStorage.getItem('clientQueryCondition')) {
      const {
        customerName, cidno, mobile, gender, agencyName, empno, groupId,
        page, limit, companyId
      } = JSON.parse(window.sessionStorage.getItem('clientQueryCondition'));

      this.setState({
        customerName, cidno, mobile, gender, agencyName, empno, groupId,
        page, limit, companyId
      }, () => {
        // this.getList(page,limit);
        this.getGroupOption(companyId);
      });
    } else {
      // this.getList(1,10);
    }
    this.getMechanismList();
  }

  // 初始化columns
  initColumns = () => {
    return [
      {
        title: '姓名',
        dataIndex: 'customerName',
        key: 'customerName',
        width: 100,
        fixed: 'left'
      },
      {
        title: '性别',
        dataIndex: 'gender',
        key: 'gender',
        render: (text) => {
          return <span>{ text === '2' ? '女' : text === '1' ? '男' : '未知' }</span>;
        }
      },
      {
        title: '年龄',
        dataIndex: 'age',
        key: 'age',
      },
      {
        title: '证件类型',
        dataIndex: 'cidtypeId',
        key: 'cidtypeId',
        render: (text) => {
          {
            return idTypeList.map((v, i) => {
              if (v.value === text) {
                return (<span key={ i }>{ v.label }</span>);
              }
            });
          }
        }
      },
      {
        title: '证件号码',
        dataIndex: 'cidno',
        key: 'cidno',
      },
      {
        title: '手机号码',
        dataIndex: 'mobile',
        key: 'mobile',
      },
      {
        title: this.state.pageNamesConfig.ofStaff || '归属业务员',
        dataIndex: 'agencyName',
        key: 'agencyName',
      },
      {
        title: this.state.pageNamesConfig.staffNo || '业务员工号',
        dataIndex: 'empno',
        key: 'empno',
      },
      {
        title: this.state.pageNamesConfig.ofCompany || '业务员机构',
        dataIndex: 'company',
        key: 'company',
      },
      {
        title: this.state.pageNamesConfig.ofTeam || '业务员团队',
        dataIndex: 'groupName',
        key: 'groupName',
      },
      {
        title: '客户来源',
        dataIndex: 'customerSource',
        key: 'customerSource',
        render: (text) => {
          return (
            <span>{ text === 'P' ? '保单' : text === 'A' ? '手工添加' : '' }</span>
          );
        }
      },
      {
        title: '操作',
        key: 'action',
        fixed: 'right',
        render: (text, record) => (
          <div className='actionBox'>
            <Link to={ `/clientManage/detail/${record.customerId}/${record.empno || "undefined"}/${record.company}/${record.groupName}/${record.agencyName}` } onClick={ () => {
              sensors.track('MerchantClientManageClick', {
                'element_content': '详情',
              });
            } }>详情</Link>
          </div>
        ),
        width: 100
      },
    ];
  };

  getMechanismList = () => {
    axios_({
      url: 'getSelectList_account',
      method: 'get',
      params: {

      },
      headers: {
        'access-token': this.props.token
      }
    }).then(res => {
      this.setState({ companyIdList: res.data });
    });
  };

  getList = (page, limit) => {
    const {
      customerName,
      cidno,
      mobile,
      gender,
      agencyName,
      empno,
      groupId,
      companyId,
    } = this.state;
    this.setState({
      tableLoading: true,
      page,
      limit,
    });
    /*存储查询条件*/
    const clientQueryCondition = {
      customerName, cidno, mobile, gender, agencyName, empno, groupId, companyId,
      page, limit
    };
    window.sessionStorage.setItem('clientQueryCondition', JSON.stringify(clientQueryCondition));
    sensors.track('MerchantClientManageSearch', {
      'company_ID': String(this.state.companyId || ''),
      'holder_name': customerName,
      'holder_mobile': mobile ? true : false,
      'holder_card_id': cidno ? true : false,
      'holder_sex': gender === '1' ? '男' : '女',
      'agency_name_wkno': String(empno || ''),
      'agency_name': agencyName,
      'agency_name_team': String(groupId || ''),
    });

    axios_({
      url: `/api/customer/customerInfo/getCustomerInfoList?page=${page}&limit=${limit}`,
      method: 'post',
      headers: { 'access-token': this.props.token },
      data: {
        customerName,
        cidno,
        mobile,
        gender,
        agencyName,
        empno,
        groupId,
        companyId: this.state.companyId,
        type: 'MERCHANT'
      }
    }).then(res => {
      if (res.data.status === 200) {
        this.setState({
          dataSource: res.data.data.rows,
          totals: res.data.data.total,
          tableLoading: false
        });
      } else {
        //请求错误
      }
    });
  };
  getGroupOption = (companyId = "") => {
    axios_({
      url: "getGroupByCompanyId",
      method: "get",
      headers: { 'access-token': this.props.token },
      params: {
        companyId
      }
    }).then(res => {
      if (res.data.code === '200') {
        this.setState({ groupOptions: res.data.data });
      }
    });
  };
  reSet = () => {
    //重置
    this.setState({
      customerName: '',
      cidno: '',
      mobile: '',
      gender: '',
      agencyName: '',
      empno: '',
      groupId: '',
      groupOptions: [],
      companyId: '',
    });
  };

  /*翻页*/
  changePage = (current, pagesize) => {
    this.setState({ page: current });
    this.getList(current, pagesize);
  };
  onShowSizeChange = (current, pagesize) => {
    this.setState({
      page: 1,
      limit: pagesize,
    });
    this.getList(1, pagesize);
  };


  render() {
    const {
      dataSource,
      groupOptions,
      totals,
      page,
      limit,
      tableLoading,
      customerName,
      cidno,
      mobile,
      gender,
      empno,
      agencyName,
      groupId,
    } = this.state;
    return (
      <div className="client_manage">
        <header className='top'>
          <div className="flex_container">
            <span className="title">所属机构：</span>
            <Select value={ this.state.companyId }
              onChange={ (value) => {
                // console.log("companyId: " + value)
                //将option中value传给保险公司名称
                this.setState({ companyId: value, groupId: '' }, () => {
                  this.getGroupOption(value);
                });
              } }
            >
              <Select.Option value="" key="">全部</Select.Option>
              {
                this.state.companyIdList.map(item => {
                  return (<Select.Option value={ item.value }
                    key={ item.value }>{ item.text }</Select.Option>);
                })
              }
            </Select>
          </div>
          <div className="flex_container">
            <span className="title">客户姓名：</span>
            <Input
              maxLength={ 50 }
              style={ {} }
              value={ customerName }
              onChange={ e => { this.setState({ customerName: e.target.value }); } }
              onKeyDown={ e => {
                e.keyCode === 13 && this.getList(1, limit);
              } }
            />
          </div>
          <div className="flex_container">
            <span className="title">客户证件号：</span>
            <Input
              maxLength={ 50 }
              value={ cidno }
              onChange={ e => { this.setState({ cidno: e.target.value }); } }
              onKeyDown={ e => {
                e.keyCode === 13 && this.getList(1, limit);
              } }
            />
          </div>
          <div className="flex_container">
            <span className="title">客户手机号：</span>
            <Input
              maxLength={ 11 }
              style={ {} }
              value={ mobile }
              onChange={ e => { this.setState({ mobile: e.target.value }); } }
              onKeyDown={ e => {
                e.keyCode === 13 && this.getList(1, limit);
              } }
            />
          </div>
          <div className="flex_container">
            <span className="title">客户性别：</span>
            <Select
              style={ {} }
              value={ gender }
              onChange={ e => { this.setState({ gender: e }); } }
            >
              <Select.Option value="" key={ 0 }>全部</Select.Option>
              <Select.Option value="1" key={ 1 }>男</Select.Option>
              <Select.Option value="2" key={ 2 }>女</Select.Option>

            </Select>
          </div>
          <div className="flex_container">
            <span className="title">{ this.state.pageNamesConfig.staffNo || '业务员工号' }：</span>
            <Input
              maxLength={ 50 }
              style={ {} }
              value={ empno }
              onChange={ e => { this.setState({ empno: e.target.value }); } }
              onKeyDown={ e => {
                e.keyCode === 13 && this.getList(1, limit);
              } }
            />
          </div>
          <div className="flex_container">
            <span className="title">{ this.state.pageNamesConfig.staffName || '业务员姓名' }：</span>
            <Input
              maxLength={ 50 }
              style={ {} }
              value={ agencyName }
              onChange={ e => { this.setState({ agencyName: e.target.value }); } }
              onKeyDown={ e => {
                e.keyCode === 13 && this.getList(1, limit);
              } }
            />
          </div>
          <div className="flex_container">
            <span className="title">{ this.state.pageNamesConfig.ofTeam || '业务员团队' }：</span>
            <Select
              showSearch
              value={ groupId }
              onChange={ e => { this.setState({ groupId: e }); } }
              filterOption={ (input, option) => {
                return option.props.children.indexOf(input) >= 0;
              } }
            >
              <Select.Option value="" key="">全部</Select.Option>
              {
                groupOptions.map(item => {
                  return (<Select.Option value={ item.value } key={ item.value }>{ item.text }</Select.Option>);
                })
              }
            </Select>
          </div>
        </header>
        <div className="button_box">
          <Button type="primary"
            icon={<SearchOutlined />}
            onClick={ () => {
              sensors.track('MerchantClientManageClick', {
                'element_content': '查询',
              });
              this.getList(1, limit);
            } }
          >查询</Button>
          <Button type="primary"
            icon={<ReloadOutlined />}
            onClick={ () => {
              sensors.track('MerchantClientManageClick', {
                'element_content': '重置',
              });
              this.reSet();
            } }
          >重置</Button>
          {
            !this.state.pageNamesConfig.batchCloseFlag && // 读页面配置是否展示按钮
            <a href={ `/api/customer/customerInfo/exportExcel?access-token=${this.props.token}&cidno=${cidno}&mobile=${mobile}&gender=${gender}&empno=${empno}&customerName=${customerName}&agencyName=${agencyName}&groupId=${groupId}&companyId=${this.state.companyId}&type=MERCHANT` } download>
              <Button type="primary"
                icon={<ArrowDownOutlined />}
                onClick={ () => {
                  sensors.track('MerchantClientManageClick', {
                    'element_content': '导出',
                  });
                } }
              >导出</Button>
            </a>
          }
          <span style={ { color: 'red', marginLeft: 15, fontSize: 12 } }>* 点击查询按钮后，系统将帮您飞速加载数据</span>
        </div>
        <div className="table">
          <Table
            bordered
            size={ 'middle' }
            // rowKey='skuFeeStrategyId'
            rowKey={ (record, index) => (index) }
            loading={ tableLoading }
            // rowClassName='table_row'
            // scroll={{x:'120%'}}
            columns={ this.initColumns() }
            dataSource={ dataSource }
            pagination={ {
              defaultPageSize: 10,
              showQuickJumper: true,
              onChange: this.changePage,
              total: totals,
              showTotal: (totals) => (`共 ${totals} 条`),
              current: page,
              showSizeChanger: true,
              onShowSizeChange: this.onShowSizeChange
            } }
          />
        </div>
      </div>
    );
  }
}


function mapState(state) {
  return {
    token: state.token
  };
}
export default connect(mapState)(ClientManage);
